/**
 * Do stringów HTML budowanych ręcznie — formattery tooltipów ECharts zwracają HTML, a nazwy marek,
 * serii i etykiet pochodzą z bazy. Bez tego nazwa projektu demo (edytowalna przez każdy trial do
 * 2026-10) wykonywała skrypt u każdego, kto najechał na wykres (HackerOne #4122460).
 */
export const escapeHtml = (value: unknown): string =>
  String(value ?? '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
